'use strict';

const { Component } = require('phy');
const { hydrate } = require('@grpn/hydration');

const { subscribe } = require('../../support/event-observer');
const {
  groupPremiumOffers,
  removePremiumOfferDuplicates,
} = require('../../support/premium-offers-helper');

const CouponsList = require('./coupons-list');

class CouponsListFilter extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);

    this.state = {
      offerType: null,
    };

    this.setOfferFilter = this.setOfferFilter.bind(this);
  }

  componentDidMount() {
    subscribe('@filter', this.setOfferFilter);
  }

  componentDidUpdate() {
    document.querySelectorAll('.coupons-list img.lazy-load').forEach(image => {
      if (image.dataset) {
        image.dataset.wasProcessed = false;
      }
    });
    window.Groupon.Utils.lazyLoadImages();
  }

  getChildContext() {
    const {
      directRedemption,
      referralSource,
      showDisruptor,
      merchantName,
    } = this.props;

    return {
      directRedemption,
      referralSource,
      showDisruptor,
      merchantName,
    };
  }

  render() {
    const {
      media = 'logo',
      routes,
      merchantSlug,
      csrfToken,
      merchantName,
      isTouch,
      attrs,
    } = this.props;
    const { premiumList, couponList } = this.getFilteredLists();

    return CouponsList({
      premium: premiumList,
      coupons: couponList,
      media,
      routes,
      merchantSlug,
      csrfToken,
      merchantName,
      isTouch,
      attrs,
    });
  }

  setOfferFilter({ offerType }) {
    this.setState({
      offerType,
    });
  }

  getFilteredLists() {
    const {
      coupons,
      premium,
      showPremium = true,
      groupPremium = true,
    } = this.props;
    const { offerType } = this.state;

    const premiumOfferLimit = showPremium ? 1 : 0;
    let formattedOffers = { premiumList: [], couponList: coupons };

    if (groupPremium) {
      formattedOffers = groupPremiumOffers(coupons, premiumOfferLimit);
    } else {
      if (premium && premium.offerId) {
        formattedOffers = removePremiumOfferDuplicates(coupons, premium);
      }
    }

    let premiumList = formattedOffers.premiumList;
    let couponList = formattedOffers.couponList;

    if (offerType) {
      [premiumList, couponList] = [premiumList, couponList].map(list =>
        list.filter(coupon => coupon.offerType === offerType)
      );
    }

    return { premiumList, couponList };
  }
}

module.exports = hydrate('CouponsListFilter', CouponsListFilter);
